import * as React from 'react'

function SvgChart(props, svgRef) {
  return (
    <svg viewBox="0 0 52 52" fill="#fff" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.436 19.382a.946.946 0 00-.945.945v13.237a.946.946 0 00.945.945h13.237a.946.946 0 00.945-.945v-5.049a.945.945 0 111.891 0v5.049a2.836 2.836 0 01-2.836 2.836H18.437a2.836 2.836 0 01-2.837-2.836V20.327a2.836 2.836 0 012.836-2.836h5.05a.945.945 0 010 1.89h-5.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.004 15.877a.946.946 0 011.337 0l3.782 3.782c.37.37.37.968 0 1.337L26.67 30.45a.945.945 0 01-.669.276h-3.782a.945.945 0 01-.945-.945V26c0-.25.1-.491.277-.668l9.454-9.455zm-7.84 10.515v2.445h2.444l8.51-8.51-2.445-2.444-8.51 8.509z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgChart)
export default ForwardRef
